export const ContentSize = {
  HEADER_HEIGHT_PX: 100,
  HEADER_THIN_HEIGHT_PX: 70,
  NEGATIVE_MARGIN_PX: 500,
  CONTENT_MAX_WIDTH: 1650,
  SP_MAX_WIDTH: 429,
  DAYCARE_CONTENT_MAX_WIDTH: 800,
} as const;

export type ContentSizeType = (typeof ContentSize)[keyof typeof ContentSize];
